import React, { forwardRef } from 'react'
import { Card, MarginBox, Row, Paragraph, Separator } from '@fs/zion-ui'
import PropTypes from 'prop-types'
import useIsMdWidth from '../../hooks/useIsMdWidth'
import { MonoText } from '../type'

function AddCardButton({ to, Icon, children, ...props }, ref) {
  const isMdWidth = useIsMdWidth()
  if (to) {
    props.noLinkStyles = true
  }
  return isMdWidth ? (
    <Card ref={ref} to={to} {...props}>
      <MonoText>
        <Row alignX="center" alignY="middle" gutters="xs">
          {Icon && <Icon size="lg" />}
          <Paragraph>{children}</Paragraph>
        </Row>
      </MonoText>
    </Card>
  ) : (
    <Card data-testid="card" {...props} ref={ref} to={to}>
      <div growY />
      <MonoText>
        <MarginBox marginY="xxs" marginX="xxs">
          <Row alignX="center">{Icon && <Icon size="lg" />}</Row>
          <Row alignX="center">
            <Paragraph centered>{children}</Paragraph>
          </Row>
        </MarginBox>
      </MonoText>
      <Separator />
      <div growY />
    </Card>
  )
}

export default forwardRef(AddCardButton)

AddCardButton.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]).isRequired,
  Icon: PropTypes.elementType,
}
